import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { PENDING_MESSAGE_ID } from 'core/constants'
import { isIE, isNotSentId } from 'core/helpers'
import { useFeatures } from 'core/hooks'
import { MessageBasic } from './MessageDefault'
import UpgradeLink from '../UpgradeLink'
import { T, FullscreenPopup, Time } from 'components/misc'
import { getNudeCover, safeModeEnabled } from 'core/utils'
import { ccpProvider } from 'core/CcpProvider'
import CONFIG from 'core/globals'

const MessageImage = ({ message, isCorrespondent, users, user, conversationUid }) => {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const isPremium = user?.premium

  let imageMessage = message.message

  if (safeModeEnabled()) {

    if (CONFIG.privateImagesNSFW.includes(message.message)) {
      imageMessage = getNudeCover()
    } else {
      imageMessage = message.message
    }
  }

  const props = {
    time: <Time since={message.sentAt}/>,
    user: isCorrespondent ? users.me : users.other,
    sent: isCorrespondent,
    pending: message.id === PENDING_MESSAGE_ID,
    failed: isNotSentId(message.id),
    shouldShowTimeStamp: message.shouldShowTimeStamp,
  }

  let { isCreditSite, hasFreeCredits } = useFeatures()
  if (isCreditSite === 0 ) {
    isCreditSite = false
  }

  const isUserImage = message.sentBy != 0
  const isImageLocked = !isUserImage &&
    !user.unlockedPrivateImages.some(unlockedPrivateImage =>
      message.message.includes(unlockedPrivateImage) || unlockedPrivateImage === message.id
    );

  const [imageSettings, setImageSettings] = useState({
      active: isUserImage ? !props.pending : !props.pending && (!isCreditSite && isPremium || isCreditSite && !isImageLocked),
      blurred: isUserImage ? false : !isCreditSite && !isPremium || isCreditSite && isImageLocked,
  })

  useEffect(() => {
    if (!isPremium && open) {
      setOpen(false)
    }
  }, [isPremium])

  const togglePopup = () => !props.pending && (isUserImage || !isCreditSite && isPremium || isCreditSite && !isImageLocked) && setOpen(!open)
  const unlockImage = async e => {
    e.preventDefault()

    if (loading) {
      return
    }

    setLoading(true)

    const [, err] = await ccpProvider.api.user.chargeForPhotoReveal({ conversationUid: conversationUid, photoUrl: message.message, messageId: message.id })

    if (!err) {
        user.unlockedPrivateImages.push(message.id)
        setImageSettings({
            active: true,
            blurred: false,
        })
    } else {
        const { onMessageSend } = CONFIG.hooks
        if (isCreditSite && err.statusCode == 402) {
          onMessageSend({ showPurchaseModal: true })
        }
    }

    setLoading(false)
  }

  return (
    <MessageBasic {...props} type="image">
      <div className={classnames('chat-image-container', { 'chat-image-ie': isIE, blurred: imageSettings.blurred, active: imageSettings.active })}>
        {!isUserImage && !isPremium && !isCreditSite && <UpgradeLink className="chat-image-button"><T>imageUpload.upgradeButton</T></UpgradeLink>}
        {!isUserImage && !isPremium && !hasFreeCredits && isCreditSite && <UpgradeLink className="chat-image-button"><T>imageUpload.unlockCreditsButton</T></UpgradeLink>}
        {!isUserImage && (isPremium || hasFreeCredits) && isCreditSite && isImageLocked &&
          <a
            href="#"
            onClick={loading ? null : unlockImage}
            className={classnames('chat-image-button upgrade-link no-under', {disabled: loading})}
            style={{
              pointerEvents: loading ? 'none' : 'auto',
              opacity: loading ? 0.5 : 1,
            }}
          >
            <T>imageUpload.unlockButton</T>
          </a>}
          <div
          className={classnames('chat-image')}
        style={{
          backgroundImage: isIE && imageSettings.blurred ? 'none' : `url("${imageMessage}")`,
        }}
        onClick={togglePopup}
      >
        <svg>
          <defs>
            <filter id="chat-image-blur">
                <feGaussianBlur stdDeviation="12"/>
              </filter>
            </defs>
            <image preserveAspectRatio="xMidYMin meet" xlinkHref={message.message} width="100%" height="100%" filter="url(#chat-image-blur)"/>
          </svg>
        </div>

      </div>
      { open &&
        <FullscreenPopup closePopup={togglePopup}>
          <img src={imageMessage}/>
        </FullscreenPopup>
      }
    </MessageBasic>
  )
}

export default MessageImage
